import { isNumber } from 'lodash';
import { rem } from 'polished';
import styled from 'styled-components';

import { theme } from '../../theme';
import { IBoxProps } from './Box.types';

export const StyledBox = styled.div<IBoxProps>`
  width: 100%;
  flex-wrap: wrap;
  ${({ display }) => display && `display: ${display};`}
  ${({ alignItems }) => alignItems && `align-items: ${alignItems};`}
  ${({ justifyContent }) =>
    justifyContent && `justify-content: ${justifyContent};`}
  ${({ xs, spacing }) =>
    xs &&
    spacing &&
    `
      @media screen and (min-width: ${theme.breakpoints.xs}) {
        width: calc(${(xs / theme.gridsystem.cols) * 100}vw - ${rem(spacing)});
      }
    `}
  ${({ sm, spacing }) =>
    sm &&
    spacing &&
    `
      @media screen and (min-width: ${theme.breakpoints.s}) {
        width: calc(${(sm / theme.gridsystem.cols) * 100}vw - ${rem(spacing)});
      }
    `}
  ${({ md, spacing }) =>
    md &&
    spacing &&
    `
      @media screen and (min-width: ${theme.breakpoints.m}) {
        width: calc(${(md / theme.gridsystem.cols) * 100}vw - ${rem(spacing)});
      }
    `}
  ${({ lg, spacing }) =>
    lg &&
    spacing &&
    `
    @media screen and (min-width: ${theme.breakpoints.l}) {
      width: calc(${(lg / theme.gridsystem.cols) * 100}vw - ${rem(spacing)});
    }
  `}
  ${({ xl, spacing }) =>
    xl &&
    spacing &&
    `
    @media screen and (min-width: ${theme.breakpoints.xl}) {
      width: calc(${(xl / theme.gridsystem.cols) * 100}vw - ${rem(spacing)});
    }
  `}
  ${({ xxl, spacing }) =>
    xxl &&
    spacing &&
    `
    @media screen and (min-width: ${theme.breakpoints.xxl}) {
      width: calc(${(xxl / theme.gridsystem.cols) * 100}vw - ${rem(spacing)});
    }
  `}
  float: ${({ float }) => float};
  position: ${({ position }) => (position ? position : 'unset')};
  top: ${({ top }) =>
    top && (isNumber(top) ? `${(top / theme.gridsystem.cols) * 100}vw` : '')};
  right: ${({ right }) =>
    right &&
    (isNumber(right) ? `${(right / theme.gridsystem.cols) * 100}vw` : '')};
  left: ${({ left }) =>
    left &&
    (isNumber(left) ? `${(left / theme.gridsystem.cols) * 100}vw` : '')};
  bottom: ${({ bottom }) =>
    bottom &&
    (isNumber(bottom) ? `${(bottom / theme.gridsystem.cols) * 100}vw` : '')};

  ${({ right, theme }) =>
    !isNumber(right) &&
    right?.sm &&
    `
    @media screen and (min-width: ${theme.breakpoints.s}) {
      right: ${(right?.sm / theme.gridsystem.cols) * 100}vw;
    }
  `}
  ${({ right, theme }) =>
    !isNumber(right) &&
    right?.md &&
    `
    @media screen and (min-width: ${theme.breakpoints.m}) {
      right: ${(right?.md / theme.gridsystem.cols) * 100}vw;
    }
  `}
  ${({ right, theme }) =>
    !isNumber(right) &&
    right?.lg &&
    `
    @media screen and (min-width: ${theme.breakpoints.l}) {
      right: ${(right?.lg / theme.gridsystem.cols) * 100}vw;
    }
  `}
  ${({ right, theme }) =>
    !isNumber(right) &&
    right?.xl &&
    `
    @media screen and (min-width: ${theme.breakpoints.xl}) {
      right: ${(right?.xl / theme.gridsystem.cols) * 100}vw;
    }
  `}
  ${({ right, theme }) =>
    !isNumber(right) &&
    right?.xxl &&
    `
    @media screen and (min-width: ${theme.breakpoints.xxl}) {
      right: ${(right?.xxl / theme.gridsystem.cols) * 100}vw;
    }
  `}
`;
